import { useContext } from "react";
import { ThemeContext } from "styled-components";

import Typography from "../Typography/Typography";

export interface ErrorMessageProps {
  /**
   Explanatory message for the error.
   */
  errorMessage?: string;
}

const ErrorMessage = ({ errorMessage }: ErrorMessageProps) => {
  const themeContext = useContext(ThemeContext);
  return (
    <Typography
      css={`
        font-size: ${themeContext.fontSizes["body"]}px;
        color: ${themeContext.colors["negative-text-color"]};
      `}
    >
      {errorMessage}
    </Typography>
  );
};

export default ErrorMessage;
